export const animateValue = (
  obj: HTMLElement,
  start: number = 0,
  end: number = 100,
  duration: number = 1000,
  numberFormat: string = 'Sv-SE',
  formatStyle: { style: "decimal" | "percent" | "currency"; currency?: string; useGrouping?: boolean },
) => {
  const formatter = new Intl.NumberFormat(numberFormat, formatStyle);

  if (duration <= 0) {
    obj.textContent = formatter.format(end);
    return;
  }

  let startTimestamp = null;

  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;

    const progress = Math.min((timestamp - startTimestamp) / duration, 1);

    if (progress < 1) {
      const animatedValue = Math.round((progress * (end - start) + start) * 10) / 10;
      obj.textContent = formatter.format(animatedValue);
      window.requestAnimationFrame(step);
    } else {
      obj.textContent = formatter.format(end);
    }
  };
  window.requestAnimationFrame(step);
};
